<bw-action-card-legacy 
  (ctaClicked)="routeToLoans()" 
  [cardConfig]="loansApplicationCardConfig">
</bw-action-card-legacy>
